import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import {
  AppBar as MaterialAppBar,
  Drawer as MaterialDrawer,
  Toolbar,
  Typography,
  IconButton,
  Divider,
  Menu,
  MenuItem,
  List,
  ListSubheader,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import {
  MdMenu,
  MdAccountCircle,
  MdLockOutline,
  MdExitToApp,
  MdPersonAdd,
  MdAssignmentInd,
  MdGroup,
  MdClass,
  MdPermIdentity,
  MdYoutubeSearchedFor,
  MdDoneAll,
  MdDashboard,
  MdContentPaste,
  MdAssignmentTurnedIn,
  MdFeaturedPlayList,
  MdCardTravel,
  MdPieChart,
  MdAssignmentLate,
  MdAddLocation,
  MdMap,
  MdAssignment,
} from 'react-icons/lib/md';

import { NAVBAR_HEIGHT, DRAWER_WIDTH } from '../../styles/constant';
import blockProps from '../../utils/blockProps';
import { signOutUser } from '../../services/authServices';
import Auth from '../Auth';
import Modal from '../Modal';
import DrawerLink from './components/DrawerLink';
import ChangePasswordForm from './components/ChangePasswordForm';

class AppShell extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  };

  state = {
    drawerOpened: true,
    menuAnchorEl: null,
  };

  toggleDrawer = () => {
    this.setState(state => ({ drawerOpened: !state.drawerOpened }));
  };

  handleAccountMenuOpen = (event) => {
    this.setState({
      menuAnchorEl: event.currentTarget,
    });
  };

  handleAccountMenuClose = () => {
    this.setState({
      menuAnchorEl: null,
    });
  };

  isLinkActive = path => this.props.location.pathname.includes(path);

  render() {
    const accountMenuOpen = Boolean(this.state.menuAnchorEl);

    return (
      <Auth>
        {({ authState }) => {
          const userInfo = authState.authenticatedUserInfo || {};

          return (
            <Container>
              <AppBar isDrawerOpened={this.state.drawerOpened}>
                <Toolbar>
                  <MenuIconButton onClick={this.toggleDrawer}>
                    <MdMenu size={24} color="#fff" />
                  </MenuIconButton>
                  <Typography variant="title" color="inherit">
                    Jagran Youth Parliament
                  </Typography>
                  <Spacer />
                  <IconButton onClick={this.handleAccountMenuOpen}>
                    <MdAccountCircle size={24} color="#fff" />
                  </IconButton>
                  <Menu
                    anchorEl={this.state.menuAnchorEl}
                    open={accountMenuOpen}
                    onClose={this.handleAccountMenuClose}
                  >
                    <UserName>{userInfo.name}</UserName>
                    <Divider />

                    <Modal
                      trigger={(
                        <MenuItem>
                          <ListItemIcon>
                            <MdLockOutline size={24} />
                          </ListItemIcon>
                          <ListItemText primary="Change Password" />
                        </MenuItem>
)}
                      render={({ closeModal }) => (
                        <ChangePasswordForm
                          onCancel={() => {
                            this.handleAccountMenuClose();
                            closeModal();
                          }}
                        />
                      )}
                      onClose={this.handleAccountMenuClose}
                    />

                    <MenuItem
                      onClick={async () => {
                        await signOutUser();
                      }}
                    >
                      <ListItemIcon>
                        <MdExitToApp size={24} />
                      </ListItemIcon>
                      <ListItemText primary="Logout" />
                    </MenuItem>
                  </Menu>
                </Toolbar>
              </AppBar>

              <Drawer open={this.state.drawerOpened} variant="persistent">
                <DrawerHeader>
                  <Logo src={require('../../images/jagran-logo.svg')} alt="dainik-jagran-logo" />
                </DrawerHeader>
                <Divider />
                <DrawerContent>
                  {userInfo.type === 'ADMIN' && (
                    <List
                      component="nav"
                      subheader={(
                        <ListSubheader component="div" disableSticky>
                          Admin
                        </ListSubheader>
)}
                    >
                      <DrawerLink
                        icon={MdDashboard}
                        path="/dashboard"
                        isActive={this.isLinkActive('dashboard')}
                        title="Dashboard"
                      />
                      <DrawerLink
                        icon={MdPersonAdd}
                        path="/manage-user"
                        isActive={this.isLinkActive('manage-user')}
                        title="Manage Users"
                      />
                      <DrawerLink
                        icon={MdAddLocation}
                        path="/venue"
                        isActive={this.isLinkActive('venue')}
                        title="Update Venue"
                      />
                    </List>
                  )}

                  <List
                    component="nav"
                    subheader={(
                      <ListSubheader component="div" disableSticky>
                        Selection Stages
                      </ListSubheader>
)}
                  >
                    {userInfo.type === 'ADMIN' && (
                      <React.Fragment>
                        <DrawerLink
                          icon={MdAssignmentInd}
                          title="Registrations"
                          path="/selection-stage/registration"
                          isActive={this.isLinkActive('/selection-stage/registration')}
                        />
                        <DrawerLink
                          icon={MdClass}
                          title="Knowledge Test"
                          path="/selection-stage/knowledgeTest"
                          isActive={this.isLinkActive('/selection-stage/knowledgeTest')}
                        />
                        <DrawerLink
                          key="group-discussion"
                          icon={MdGroup}
                          title="Group Discussion"
                          path="/selection-stage/groupDiscussion"
                          isActive={this.isLinkActive('/selection-stage/groupDiscussion')}
                        />
                        <DrawerLink
                          key="personal-interview"
                          icon={MdPermIdentity}
                          title="Personal Interview"
                          path="/selection-stage/personalInterview"
                          isActive={this.isLinkActive('/selection-stage/personalInterview')}
                        />
                      </React.Fragment>
                    )}
                    {['ADMIN', 'CITY_IMPACT_MANAGER'].includes(userInfo.type) && (
                      <DrawerLink
                        icon={MdYoutubeSearchedFor}
                        title="Research Activity"
                        path="/selection-stage/researchActivity"
                        isActive={this.isLinkActive('/selection-stage/researchActivity')}
                      />
                    )}
                    {userInfo.type === 'ADMIN' && (
                      <DrawerLink
                        icon={MdDoneAll}
                        title="Selected"
                        path="/selection-stage/selected"
                        isActive={this.isLinkActive('/selection-stage/selected')}
                      />
                    )}
                  </List>

                  <List
                    component="nav"
                    subheader={(
                      <ListSubheader component="div" disableSticky>
                        Session Track
                      </ListSubheader>
)}
                  >
                    <DrawerLink
                      icon={MdAssignmentTurnedIn}
                      path="/attendance-sheet"
                      isActive={this.isLinkActive('attendance-sheet')}
                      title="Attendance Sheet"
                    />
                    <DrawerLink
                      icon={MdContentPaste}
                      path="/attendance-report"
                      isActive={this.isLinkActive('attendance-report')}
                      title="Attendance Report"
                    />
                    <DrawerLink
                      icon={MdFeaturedPlayList}
                      path="/mp-track"
                      isActive={this.isLinkActive('mp-track')}
                      title="MP Track"
                    />
                    {userInfo.type === 'ADMIN' && (
                      <DrawerLink
                        icon={MdMap}
                        path="/db-index"
                        isActive={this.isLinkActive('db-index')}
                        title="DB Index"
                      />
                    )}
                    <DrawerLink
                      icon={MdAssignment}
                      path="/bill-track"
                      isActive={this.isLinkActive('bill-track')}
                      title="Bill Track"
                    />
                    <DrawerLink
                      icon={MdAssignmentLate}
                      path="/issue-track"
                      isActive={this.isLinkActive('issue-track')}
                      title="Issue Track"
                    />
                    <DrawerLink
                      icon={MdCardTravel}
                      path="/budget-track"
                      isActive={this.isLinkActive('budget-track')}
                      title="Budget Track"
                    />
                    {userInfo.type === 'ADMIN' && (
                      <DrawerLink
                        icon={MdPieChart}
                        path="/productivity"
                        isActive={this.isLinkActive('productivity')}
                        title="Productivity"
                      />
                    )}
                  </List>
                </DrawerContent>
              </Drawer>

              <ContentContainer isDrawerOpened={this.state.drawerOpened}>
                {this.props.children}
              </ContentContainer>
            </Container>
          );
        }}
      </Auth>
    );
  }
}

export default withRouter(AppShell);

const Container = styled.div`
  position: relative;
`;

const AppBar = styled(blockProps(MaterialAppBar, ['isDrawerOpened']))`
  height: ${NAVBAR_HEIGHT}px;
  left: ${props => (props.isDrawerOpened ? `${DRAWER_WIDTH}px` : '0')} !important;
  width: ${props => (props.isDrawerOpened ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%')} !important;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
`;

const Spacer = styled.div`
  flex: 1;
`;

const Drawer = styled(MaterialDrawer)`
  width: ${DRAWER_WIDTH}px;

  & > div {
    width: ${DRAWER_WIDTH}px;
    transition: 450ms cubic-bezier(0.23, 1, 0.32, 1) !important;
  }
`;

const DrawerHeader = styled.div`
  width: 100%;
  height: 60px;
  margin-bottom: 5px;
`;

const DrawerContent = styled.div`
  max-height: calc(100% - 70px);
  overflow: hidden;

  &::-webkit-scrollbar {
    display: none;
  }

  &:hover {
    overflow: auto;
  }
`;

const Logo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const ContentContainer = styled.div`
  position: relative;
  top: ${NAVBAR_HEIGHT}px;
  left: ${props => (props.isDrawerOpened ? `${DRAWER_WIDTH}px` : '0')};
  width: ${props => (props.isDrawerOpened ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%')};
  padding: 15px;
  min-height: calc(100vh - ${NAVBAR_HEIGHT}px);
  background-color: ${props => props.theme.backgroundColor};
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);

  & > div {
    margin: 0 auto;
    max-width: 1200px;
  }
`;

const MenuIconButton = styled(IconButton)`
  margin-right: 10px !important;
`;

const UserName = styled(ListItem)`
  outline: none !important;
  color: rgba(0, 0, 0, 0.5);
`;



// WEBPACK FOOTER //
// ./src/components/AppShell/AppShell.js